/* @flow */
import React from 'react';
import cx from 'classnames';
import { Container } from 'flux/utils';
import AddButton from 'components/AddButton.jsx';
import { ManagerItemPlaceholderCard } from './ManagerItemCard.jsx';
import BankAccountsManagerItem from './BankAccountsManagerItem.jsx';
import ExternalAccountResourceActions from 'payments/actions/ExternalAccountResourceActions';
import ExternalAccountResourceStore from 'payments/stores/ExternalAccountResourceStore';
import LinkBankAccountModal from './LinkBankAccountModal.jsx';
import SchoolBankAccountsManagerItem from './SchoolBankAccountsManagerItem.jsx';
import SchoolBankAccountsPendingItem from './SchoolBankAccountsPendingItem.jsx';
import ExternalAccountResources from 'collections/ExternalAccountResources';
import ConnectedBankAccounts from 'collections/ConnectedBankAccounts';
import ConnectedBankAccountStore from 'payments/stores/ConnectedBankAccountStore';
import { CONNECTED_BANK_ACCOUNT_TYPE, INDIVIDUAL_BANK_ACCOUNT_TYPE } from 'entities/ExternalAccountResource';
import { mountModal } from 'lib/modal';

type State = {
  loading: boolean,
  externalAccountResources: ExternalAccountResources,
  connectedBankAccounts: ConnectedBankAccounts,
}

class BankAccountsManager extends React.Component {
  static getStores() {
    return [
      ExternalAccountResourceStore,
      ConnectedBankAccountStore,
    ];
  }

  static calculateState(prevState: ?State) {
    return {
      externalAccountResources: ExternalAccountResourceStore.getExternalAccountResources(),
      connectedBankAccounts: ConnectedBankAccountStore.getConnectedBankAccounts(),
      loading: prevState ? prevState.loading : true,
    };
  }

  componentWillMount = () => {
    Promise.all([ExternalAccountResourceActions.load()]).then(
      () => this.mounted && this.setState({ loading: false }),
      () => this.mounted && this.setState({ loading: false }),
    );
  }

  componentDidMount = () => {
    this.mounted = true;
  }

  componentWillUnmount = () => {
    this.mounted = false;
  }

  mounted: boolean;

  shouldDisplayLoadingIndicator = () => {
    return (
      this.state.loading &&
      this.state.externalAccountResources.length <= 0 &&
      this.state.connectedBankAccounts.length <= 0
    );
  }

  renderConnectedBankAccounts() {
    return this.state.connectedBankAccounts.map(connectedBankAccount => {
      if (connectedBankAccount.isPending() && !connectedBankAccount.getCanManage()) {
        return (
          <SchoolBankAccountsPendingItem
            key={connectedBankAccount.id}
            connectedBankAccount={connectedBankAccount}
          />
        );
      }
      return null;
    });
  }

  renderBankAccounts() {
    return this.state.externalAccountResources.map(externalAccountResource => {
      if (externalAccountResource.getType() === INDIVIDUAL_BANK_ACCOUNT_TYPE) {
        return (
          <BankAccountsManagerItem
            key={externalAccountResource.getBankAccount().id}
            bankAccount={externalAccountResource}
          />
        );
      } else if (externalAccountResource.getType() === CONNECTED_BANK_ACCOUNT_TYPE) {
        const connectedBankAccount = externalAccountResource.getConnectedAccount();
        return connectedBankAccount && (
          <SchoolBankAccountsManagerItem
            key={connectedBankAccount.id}
            externalAccount={externalAccountResource}
          />
        );
      }
      return null;
    });
  }

  renderBody() {
    if (this.shouldDisplayLoadingIndicator()) {
      return <ManagerItemPlaceholderCard />;
    }
    return (
      <div>
        {this.state.connectedBankAccounts.length > 0 && this.renderConnectedBankAccounts()}
        {this.state.externalAccountResources.length > 0 && this.renderBankAccounts()}
        <AddButton
          size="large"
          onClick={() => mountModal(<LinkBankAccountModal />, this)}>
          Add a bank account
        </AddButton>
      </div>
    );
  }

  render() {
    return (
      <div className={cx('BankAccountsManager', this.props.className)}>
        {this.renderBody()}
      </div>
    );
  }
}

export default Container.create(BankAccountsManager);



// WEBPACK FOOTER //
// ./src/payments/components/BankAccountsManager.jsx